module.exports = __webpack_public_path__ + "static/media/social-dribbble.7c554482.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-dribbble.svg
// module id = 117
// module chunks = 0